import { Component, OnInit, ViewChild } from '@angular/core';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { NothingComponent } from '../../objects/nothing/nothing.component';
import { AlertComponent } from '../../objects/alert/alert/alert.component';
import { DataService } from 'src/app/Service/data.service';
import { NotifyService } from 'src/app/Service/notify.service';
import { Clase } from 'src/app/Models/clase/clase';
import { SubClase } from 'src/app/Models/subclase/sub-clase';
import { SubGrupo } from 'src/app/Models/subgrupo/sub-grupo';
import { Articulo } from 'src/app/Models/articulo/articulo';
import { ArticuloEditComponent } from '../articulo-edit/articulo-edit.component';
import { ALertOption } from 'src/app/Models/alert/alert-option';
import { StringToNumberPipe } from '../../../string-to-number.pipe'
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-articulo',
    templateUrl: './articulo.component.html',
    styleUrls: ['./articulo.component.css'],
    providers:[StringToNumberPipe]
    
})
export class ArticuloComponent implements OnInit {
    @ViewChild(LoadingComponent, null) public loading: LoadingComponent;
    @ViewChild(NothingComponent, null) public nothing: NothingComponent;
    @ViewChild(AlertComponent, null) public alert: AlertComponent;
    @ViewChild(ArticuloEditComponent, null) public fmarticulonew: ArticuloEditComponent;
    public articulo:Articulo= new Articulo();
    public articulos:Articulo[]=[];
    public clases: Clase[] = [];
    public subclases: SubClase[] = [];
    public subgrupos: SubGrupo[] = [];
    public pagarticulo:any = 1;
    public total:number=0;
    public options: ALertOption = new ALertOption();
    public search = { top: 20, clase: 0, subclase: 0, subgrupo: 0, nombre: '', codigo:'', opcion:'nombre',  scale: 'DESC', fechaprogd: this.data.DateNowCurrent(), fechaprogh: this.data.DateNowCurrent() }
    constructor(private title: Title,private data: DataService, private notify: NotifyService) { }

    ngOnInit() {
        this.title.setTitle('Articulos | Sistema de ventas');
        this.GetClase();
        
    }

    
    GetClase() {
        this.loading.show('cargando datos');
        this.data.GetSimple(this.data.api.clase).subscribe(r => {
            if (r.length < 1) {
                console.log(r);
                this.clases=[];
            }else{
                this.clases=r;
            }
        }, e => { console.log(e); },()=>{this.GetSubClase();});
    }
    GetSubClase() {
        this.loading.show('cargando datos');

        this.data.GetFromValue(this.data.api.subclase,'idclase',this.search.clase.toString()).subscribe(r => {
            if (r.length < 1) {
                console.log(r);
                this.subclases=[];
            }else{
                this.subclases=r;
            }
        }, e => { console.log(e); },()=>{ this.GetSubGrupo();});
    }
    GetSubGrupo() {
        this.loading.show('cargando datos');
        console.log(this.search.subgrupo);
        
        this.data.GetFromValue(this.data.api.subgrupo,'idclase',this.search.subclase.toString()).subscribe(r => {
            if (r.length < 1) {
                console.log(r);
                this.subgrupos=[];
            }else{
                this.subgrupos=r;
            }
        }, e => { console.log(e); },()=>{this.GetArticulo();});
    }
    GetArticulo(){
        this.loading.show('cargando datos');
        this.articulos=[];
        console.log(this.search);
        
        this.data.Search('Articulos',this.search).subscribe(r=>{
            this.loading.hide();
            if (r.length<1) {
                console.log(r);
                this.articulos=[];
            }else{
                this.articulos=r;

                this.total = this.articulos.length;
            }
        },e=>{console.log(e)});
    }
    
    ShowNewArticulo(){
        this.fmarticulonew.articulo = new Articulo();
        this.fmarticulonew.iseditable = false;
        this.fmarticulonew.show(()=>{this.GetArticulo();});
    }

    ShowEditArticulo(i){
        
        this.fmarticulonew.articulo = null;
        this.fmarticulonew.iseditable= true;
        this.fmarticulonew.articulo = i;
        
        console.log(i);
        this.fmarticulonew.show(()=>{this.GetArticulo();});
    }
    
    SetSearchOption(i:string){
        
        this.search.opcion = i;
        this.search.scale=='DESC'? this.search.scale='ASC':this.search.scale='DESC';
        this.GetArticulo();
    }


    async DeleteArticulo(i){
        let articulo = i as Articulo;
        this.data.notify('Estimado usuario, ¿Estas seguro de eliminar el articulo CD: '+articulo.codigo+' del sistema?','Eliminar articulo',this.data.alertType.question,new ALertOption(true,true),async ()=>{
            this.data.AsyncDelete(this.data.api.articulos,i.idproduct).then(r=>{
                if (r.status==="success") {
                    this.data.notify(r.message,"Exito",this.data.alertType.success)
                }
                
            }).catch(e=>{
                if (e.error) {
                    this.data.notify(e.error.message,"Error",this.data.alertType.error)
                }else{
                    console.log(e);
                    
                }
            }).finally(()=>this.GetArticulo());
        });
    }
    

}
